import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Home, User, Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
// Shop and Settings tabs removed in Module 28 (WP-NAV.6/WP-NAV.9) — both are now
// popups opened from the top HUD (centered Shop button, top-right Settings gear);
// neither exists as a route anymore. Freed slots are reserved for future features
// (Events/Collection/Achievements/…, per the module's bug doc).
const NAV_TABS = [
    { to: '/', slug: 'home', Icon: Home, labelKey: 'nav.home', end: true },
    { to: '/live', slug: 'live', Icon: Zap, labelKey: 'nav.live' },
    { to: '/profile', slug: 'profile', Icon: User, labelKey: 'nav.profile' },
];
export function NavigationBar() {
    const { t } = useTranslation();
    return (_jsx("nav", { className: "navigation-bar", "aria-label": t('nav.ariaLabel'), children: NAV_TABS.map(({ to, slug, Icon, labelKey, end }) => (_jsxs(NavLink, { to: to, ...(end ? { end } : {}), className: ({ isActive }) => `navigation-bar__tab navigation-bar__tab--${slug}${isActive ? ' navigation-bar__tab--active' : ''}`, children: [_jsx(Icon, { size: 22, "aria-hidden": "true" }), _jsx("span", { className: "navigation-bar__label", children: t(labelKey) })] }, to))) }));
}
